import axios from "axios";
import store from '@/store'
import qs from 'qs'
import {setCookie,getCookie, removeCookie,clearCookie} from "@/utils/auth";
import {IsDevelop} from "@/utils/utitiles";

let msgBox = null;
// axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
axios.defaults.headers = {
  'Cache-Control': 'no-cache',
  'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
}
//这里根据域名关键字用来判断是否是正式环境，如果不是正式环境则调用测试环境api地址
const devArray=['net-book','net-accounting'];
let hostName=location.host.toLowerCase();
let is_dev = false;
devArray.forEach((item,index)=>{
  if(hostName.indexOf(item)>-1) {
    is_dev = true;
  }
});
//这里根据域名关键字用来判断是否是预测试环境，如果不是则调用测试环境api地址
const urlArray=['accounting-backup'];
let is_prevtest = false;
urlArray.forEach((item,index)=>{
  if(hostName.indexOf(item)>-1) {
    is_prevtest = true;
  }
});
// 创建axios实例
const service = axios.create({
  baseURL: is_dev?'https://web.net-book.cn/api':(is_prevtest?'http://221.224.91.206:8093/nfapi':(IsDevelop()?'http://192.168.1.5:8081':'http://221.224.91.206:8093')),//process.env.VUE_APP_BASE_URL,
  timeout: 30000, // 超时
});

// request拦截器
 service.interceptors.request.use(
  async (config) => {
    store.commit('loadStatus', true)
    //先生成token验证票据
    await initToken(config);
    if (config.method === 'post' && config.data) {
      if(config.headers["Content-Type"].indexOf('multipart/form-data')<0) {
        config.data = qs.stringify(config.data)
      }
    }
    // get请求映射params参数
    if (config.method === "get" && config.params) {
      let url = config.url + "?";
      for (const propName of Object.keys(config.params)) {
        const value = config.params[propName];
        let part = encodeURIComponent(propName) + "=";
        if (value !== null && typeof value !== "undefined") {
          if (typeof value === "object") {
            for (const key of Object.keys(value)) {
              let params = propName + "[" + key + "]";
              let subPart = encodeURIComponent(params) + "=";
              url += subPart + encodeURIComponent(value[key]) + "&";
            }
          } else {
            url += part + encodeURIComponent(value) + "&";
          }
        }
      }
      url = url.slice(0, -1);
      config.params = {};
      config.url = url;
    }
    return config;
  },
  (error) => {
    store.commit('loadStatus', false)
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (res) => {
    //判断当前请求是否设置了不显示Loading(不显示自然无需隐藏)
    store.commit('loadStatus', false)
    return handleError(res);
  },
  (error) => {
    store.commit('loadStatus', false)
    if (error.message !== "Network Error") {
      return handleError(error.response);
    } else {
      // removeToken();
    }
  }
);

function handleError(res) {
  const code = res.status || 200;
  if (code === 200) {
    if (res.config.responseType === "arraybuffer") {
      return {
        data: res.data,
        success: true
      }
    } else {
      return {
        ...res.data,
        success: true
      }
    }
  } else if (code === 110) {
    setTimeout(() => {
      clearCookie();
      location.reload();
    }, 1500);
    if (msgBox) return false;
    clearCookie();
    msgBox = null;
  } else {
    if (msgBox) return false;
    msgBox = null;
    return res.data;
  }
}
//生成授权的Token
async function initToken(config) {
  await axios.post(service.defaults.baseURL + '/fmsapi/common/GetToken').then(res => {
    if (res.data.code === "0000") {
      let {access_token, token_type} = res.data.result;
      config.headers["Authorization"] = "Bearer " + access_token;
      config.headers["ShowLoading"]=true;
    }
  })
}

export default service;
